var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2595",
    "data-name": "Groupe 2595",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3765",
    "data-name": "Trac\\xE9 3765",
    d: "M65.408,227.333A15.117,15.117,0,1,0,80.526,242.45,15.118,15.118,0,0,0,65.408,227.333Zm-4.384,21.725H54.789V236.781h6.235v11.36h0Zm7.5-11.567V246.1H62.292V234.348h6.235Zm7.5,13.062H69.8V239.065H76.03Z",
    transform: "translate(-50.292 -227.333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedIcon);
export default __webpack_public_path__ + "static/media/finished-icon.92151c0008679bb180bea110f1bacb07.svg";
export { ForwardRef as ReactComponent };